var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagOpenAccess = function SvgTagOpenAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 9 9"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#476BC2",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    clipPath: "url(#tag-open-access_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#476BC2",
    d: "M7.125 4.125h-5.25a.75.75 0 0 0-.75.75V7.5c0 .414.336.75.75.75h5.25a.75.75 0 0 0 .75-.75V4.875a.75.75 0 0 0-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 4.125v-1.5a1.875 1.875 0 0 1 2.987-1.511"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tag-open-access_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9v9H0z"
  })))));
};
export default SvgTagOpenAccess;